import { Form, Input } from "antd"
import React from "react"

interface InitialSignatureBlockProps {
  fieldKey: string
  initialValue?: string
}

export function InitialSignatureBlock({
  fieldKey,
  initialValue
}: InitialSignatureBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "signer_label"]}
        label="Signature Label"
        initialValue={initialValue}
      >
        <Input placeholder="e.g. Client Signature" />
      </Form.Item>
    </>
  )
}
